export const getStore = state => state.monitoredDocumentCompare || {};

export const getMonitoredDocumentCompare = state => getStore(state).monitoredDocumentCompare || {};

export const isFetching = state => getStore(state).fetching;
export const isFetched = state => getStore(state).fetched;
export const hasFailed = state => getStore(state).failed;
